<template>
	<div>
		<erji-title :titleName="this.titleName" :fatherName = "this.fatherName"></erji-title>
		<div class="erji-content">
			<list :listId="this.childId" :page="this.page"></list>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'elist',
		data(){
			return{
				titleName:'',
				fatherName:'',
				id:'',
				childId:'',
				page:15
			}
		},
		methods:{
			//请求分类信息
			res_menusClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// console.log('response090',response)
								this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求父类信息
			res_fatherClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// console.log('response090',response)
								this.fatherName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
		},
		created() {
			this.childId = this.$route.query.category_id;
			this.res_menusClass(this.childId);
			
			this.res_fatherClass(this.$route.params.id)
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					this.childId = to.query.category_id;
					this.res_menusClass(this.childId)
			}
		},
		mounted(){
			
		}
	}
</script>

<style>
</style>